<template>
  <el-dropdown
    trigger="click"
    @visible-change="visibleChange"
    @command="handleAccount"
  >
    <span ref="dropdownRef">
      <cnd-icon name="cnd-account" />
      <span class="user">{{ userInfo.name }}</span>
    </span>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item
          v-for="(item, index) in dropdownMenu"
          :key="index"
          :command="item.key"
        >
          {{ item.name }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script>
export default {
  name: 'HeaderAccount',
  props: {
    // 用户信息
    userInfo: {
      type: Object,
      default: () => {}
    },
    // 用户下拉菜单
    dropdownMenu: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      if (this.visible) {
        this.$refs.dropdownRef.click()
        setTimeout(() => {
          this.$refs.dropdownRef.click()
        }, 500)
      }
    })
  },

  methods: {
    // 点击用户菜单
    handleAccount(v) {
      this.$emit('handleAccount', v)
    },
    visibleChange(visible) {
      this.visible = visible
    }
  }
}
</script>
